import { createContext } from "react";

export const GlobalContext = createContext({
    global: {},
});

export default GlobalContext;
